import { combineReducers } from "redux";

import { reducer as validarDocumento } from "./actions/validarDocumento";

export const servicos = combineReducers({
  validarDocumento
});
